import { Button, Modal, Table } from 'react-bootstrap';
import { DataAmigavel } from '@/shared/utils/datas';
import { GetPontuacoes, PontuacaoDefensor, PontuacaoEvento } from '../periodo.service';
import { TipoPeriodoDescansoList } from '@/shared/constants/enumlist';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';

export default function PontuacoesPage() {
  const [pontuacoes, setPontuacoes] = useState<PontuacaoDefensor[]>([]);
  const [loaded, setLoaded] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [eventosSelecionados, setEventosSelecionados] = useState<PontuacaoEvento[]>([]);
  const [defensorSelecionado, setDefensorSelecionado] = useState<{ id: number; nome: string } | null>(null);

  useEffect(() => {
    GetPontuacoes()
      .then((result) => {
        setPontuacoes(result);
        setLoaded(true);
      })
      .catch((error) => {
        toast.error('Erro ao carregar pontuações: ' + error);
        setLoaded(true);
      });
  }, []);

  const handleShowModal = (defensor: { id: number; nome: string }, eventos: PontuacaoEvento[]) => {
    setDefensorSelecionado(defensor);
    setEventosSelecionados(eventos);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setDefensorSelecionado(null);
    setEventosSelecionados([]);
  };

  const getTipoPeriodoNome = (tipo?: number): string => {
    if (tipo === undefined || tipo === null) return '-';
    const tipoEncontrado = TipoPeriodoDescansoList.find((t) => t.value === tipo);
    return tipoEncontrado ? tipoEncontrado.name : '-';
  };

  if (!loaded) {
    return (
      <div className="container mt-4">
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Carregando...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="row">
        <div className="col-md-8">
          <h3>Pontuações</h3>
          <span className="blockquote-footer pb-4 text-end">
            Lista de defensores com pontuações registradas.
          </span>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          {pontuacoes.length === 0 ? (
            <div className="text-center text-muted py-4">
              Nenhum defensor com pontuações encontrado.
            </div>
          ) : (
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Defensor</th>
                  <th className="text-center">Total de Pontos</th>
                  <th className="text-center">Ações</th>
                </tr>
              </thead>
              <tbody>
                {pontuacoes.map((pontuacao) => (
                  <tr key={pontuacao.defensor.id}>
                    <td>{pontuacao.defensor.nome}</td>
                    <td className="text-center">
                      <strong>{pontuacao.totalPontos}</strong>
                    </td>
                    <td className="text-center">
                      <Button
                        variant="info"
                        size="sm"
                        onClick={() =>
                          handleShowModal(pontuacao.defensor, pontuacao.eventos)
                        }
                      >
                        Ver Eventos
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </div>
      </div>

      <Modal show={showModal} onHide={handleCloseModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            Eventos de Pontuação - {defensorSelecionado?.nome}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {eventosSelecionados.length === 0 ? (
            <div className="text-center text-muted py-4">
              Nenhum evento encontrado.
            </div>
          ) : (
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th>Tipo</th>
                  <th>Tipo Período</th>
                  <th>Data Inicial</th>
                  <th>Data Final</th>
                  <th>Defensoria</th>
                  <th>Anotação/Motivo</th>
                </tr>
              </thead>
              <tbody>
                {eventosSelecionados.map((evento, index) => (
                  <tr key={`${evento.tipo}-${evento.id}-${index}`}>
                    <td>
                      <span
                        className={
                          evento.tipo === 'periodo'
                            ? 'badge bg-primary'
                            : 'badge bg-success'
                        }
                      >
                        {evento.tipo === 'periodo' ? 'Período' : 'Substituição'}
                      </span>
                    </td>
                    <td>{getTipoPeriodoNome(evento.tipo_periodo)}</td>
                    <td>
                      {evento.data_inicial
                        ? DataAmigavel(evento.data_inicial)
                        : '-'}
                    </td>
                    <td>
                      {evento.data_final
                        ? DataAmigavel(evento.data_final)
                        : '-'}
                    </td>
                    <td>{evento.defensoria || '-'}</td>
                    <td>{evento.motivo || evento.anotacao || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
          <div className="mt-3">
            <strong>Total de pontos: {eventosSelecionados.length}</strong>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
